export default __webpack_public_path__ + "static/media/GR00046-creditcard.fe596270.svg";